import phone from 'phone';
import phoneFormatter from 'phone-formatter';
import _ from "lodash";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isWebchatMobile = (mobile) => UUID_RE.test(String(mobile || '').trim());

const formatMobileBeauty = mobile => {
	if (isWebchatMobile(mobile)) return 'Webchat';

	const result = phone(mobile);
	let number = '';

    if (result && result.isValid) {
        number = result.phoneNumber;
    }

	if (!number) {
		return '';
	}

	return phoneFormatter.format(number, '(NNN) NNN-NNNN');
};

const formatMobileE164 = mobile => {
	const result = phone(mobile);
	if (result && result.isValid) {
		return result.phoneNumber;
	}

	return '';
};

const isMobileValid = mobile => {
	const result = phone(mobile);
	return !!(result && result.isValid);
};

const mobileCleanup = mobile => {
	return mobile.replace(/\s|\(|\)|\-|\_/g, '');
};

const basicMobileFormat = mobile => {
	mobile = mobile.replace(/\s|\(|\)|-|^1|\+|/g, '');
	if (mobile.charAt(0) !== 1) {
		mobile = `1${mobile}`;
	}

	return `+${mobile}`;
};

const forceFormat = mobile => {
	if (isWebchatMobile(mobile)) return 'Webchat';

	let res = formatMobileBeauty(mobile);
	if (res === '') {
		res = (mobile || '')
			.replace(/^1|[^\d]+1/g, '')
			.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
	}

	return res;
};

const formatMessage = (data, message) => {
    const regularEx = /{{([\s\S]+?)}}/g;
    let matches = message.match(regularEx);

    let output = message;
    if (matches && matches.length) {
        matches = _.map(matches, match => {
            return match.slice(2, match.length - 2).trim();
        });

        const templateData = {};
        matches.forEach(match => {
            templateData[match] = '';
        });

        data.forEach(detail => {
            templateData[detail.field] = detail.value;
        });

        _.templateSettings.interpolate = regularEx;
        const compiled = _.template(message);

        output = compiled(templateData);
    }

    return output;
}

export default {
	formatMobileBeauty,
	formatMobileE164,
	isMobileValid,
	isWebchatMobile,
	basicMobileFormat,
	mobileCleanup,
	forceFormat,
	formatMessage,
};
